module.exports = __webpack_public_path__ + "static/img/reject.70d653c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reject.png
// module id = Ycmf
// module chunks = 1